var _circle, _circle2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityThreeDotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9992,
    cy: 24.0006,
    r: 17.966,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9994 41.9666C33.9217 41.9666 41.9653 33.923 41.9653 24.0006C41.9653 20.9062 41.183 17.9945 39.8054 15.4525C36.6473 12.6947 32.5154 11.0239 27.9933 11.0239C18.071 11.0239 10.0273 19.0676 10.0273 28.9899C10.0273 32.0843 10.8097 34.996 12.1873 37.538C15.3454 40.2959 19.4773 41.9666 23.9994 41.9666Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75C24.4142 24.75 24.75 24.4142 24.75 24C24.75 23.5858 24.4142 23.25 24 23.25C23.5858 23.25 23.25 23.5858 23.25 24C23.25 24.4142 23.5858 24.75 24 24.75Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.5C24.4142 19.5 24.75 19.1642 24.75 18.75C24.75 18.3358 24.4142 18 24 18C23.5858 18 23.25 18.3358 23.25 18.75C23.25 19.1642 23.5858 19.5 24 19.5Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24.4142 30 24.75 29.6642 24.75 29.25C24.75 28.8358 24.4142 28.5 24 28.5C23.5858 28.5 23.25 28.8358 23.25 29.25C23.25 29.6642 23.5858 30 24 30Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityThreeDotIcon);
export default __webpack_public_path__ + "static/media/activityThreeDotIcon.3c009f9471b88537ee54c12bdb01f01f.svg";
export { ForwardRef as ReactComponent };